import * as React from 'react';

import './Separator.less';

interface Props {
  mg?: string;
  height?: string;
}

const Separator: React.FunctionComponent<Props> = ({
  mg = '0 15px',
  height = '30px',
}) => <div className="separator" style={{ height, margin: mg }} />;

export default Separator;



// WEBPACK FOOTER //
// ./src/components/Separator/Separator.tsx